/**
 * The waitlist's one call: POST https://api.retail.dwlf.co.uk/v1/waitlist (DWLF-584). It is
 * dwlf-retail-api's only unauthenticated route, so it carries no token and goes through neither
 * apiClient (SPT, with its session) nor the identity client: both builds call it from public pages.
 * The API answers the same 202 whether or not the address was already on the list.
 */
import { RETAIL_API_URL } from '../../config/retailIdentity';
import { PRIVACY_NOTICE_VERSION, WAITLIST_COPY } from './waitlistCopy';

export class WaitlistError extends Error {
  constructor(message) {
    super(message);
    this.name = 'WaitlistError';
  }
}

/**
 * Join the waitlist. Resolves when the API took the join; rejects with a WaitlistError whose message
 * is fit to show the person.
 * `join`: { email, interests, consent, place, website } — `website` is the hidden honeypot field.
 */
export async function joinWaitlist(join, fetchImpl = (...args) => fetch(...args)) {
  let res;
  try {
    res = await fetchImpl(`${RETAIL_API_URL}/waitlist`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...join, privacyNoticeVersion: PRIVACY_NOTICE_VERSION }),
    });
  } catch {
    throw new WaitlistError(WAITLIST_COPY.errors.failed);
  }
  if (res.status === 202) return;
  if (res.status === 429) throw new WaitlistError(WAITLIST_COPY.errors.busy);
  throw new WaitlistError(WAITLIST_COPY.errors.failed);
}
